import { LEAGUE } from "../models/NBA";
import { getNbaTeamsApiV1NbaTeamsGet, getWnbaTeamsApiV1WnbaTeamsGet, Team } from '../client';
import { showErrorNotification } from "../utils/errors";

export const getTeams = async (league: LEAGUE): Promise<Team[]> => {
    try  {
        const res = league === LEAGUE.NBA ? await getNbaTeamsApiV1NbaTeamsGet() : await getWnbaTeamsApiV1WnbaTeamsGet()
        if (res.error !== undefined) throw new Error('Error getting teams')
        const data = res.data as Team[]
        return data

    } catch (error) {
        showErrorNotification({
            id: 'league-data-fetch-error',
            title: 'Unable to load league data',
            message: 'Could not retrieve roster or team data. Please check your connection.',
            error
        });
        return []
    }
}